// test238
(238 && 0);
